import { EEidType } from '../types/enums/eid-type';
import { IEId } from '@signing-page/signing/types/eid';
import { translate } from '@/helpers/translation.helper';

export function getEIdOptions(): IEId[] {
  return [
    {
      name: 'BankId SE',
      key: EEidType.SE,
      icon: 'bankid-color',
    },
    {
      name: 'BankID No',
      key: EEidType.NO,
      height: 220,
      width: 400,
      icon: 'nemid',
    },
    {
      name: 'NemID DK',
      key: EEidType.NemID,
      height: 470,
      width: 320,
      icon: 'nemid',
    },
    {
      name: 'NemID for erhverv',
      key: EEidType.NemIDOrg,
      height: 470,
      width: 320,
      icon: 'nemid',
    },
    {
      name: 'NemID nøglefil',
      key: EEidType.NemIDKeyFile,
      height: 350,
      width: 440,
      icon: 'nemid-organization',
    },
    {
      name: 'MitID',
      key: EEidType.MitID,
      icon: 'mitid-dark',
    },
    {
      name: translate('bankid-finland'),
      key: EEidType.BankIDFI,
      icon: 'nemid',
    },
  ];
}
